



































































import Vue from 'vue';
// import * as firebase from '@/plugins/firebase';
import {
  brand,
  Brand,
  booth,
  Booth,
  item,
  Item,
  firebase,
} from 'mostra';

// import brand, { Brand } from '@/modules/exhibitor/brand';
// import booth, { Booth } from '@/modules/exhibitor/booth';
// import item, { Item } from '@/modules/exhibitor/item';
import { uniq } from 'lodash';

const uu = (docs: any[]): any[] => {
  const ls = uniq(docs.map((d) => d.uid));
  return ls;
};

const pv = async (brandId: string, names: string[]): Promise<any[]> => {
  const qs = await firebase
    .db()
    .collection('visitors_v1')
    .where('brandId', '==', brandId)
    .where('name', 'in', names)
    .get();

  const ls: any[] = [];
  qs.forEach((doc) => {
    // console.log(doc)
    ls.push(doc.data());
  });
  return ls;
};

const pvbt = async (brandId: string, boothId: string, names: string[]): Promise<any[]> => {
  const qs = await firebase
    .db()
    .collection('visitors_v1')
    .where('brandId', '==', brandId)
    .where('boothId', '==', boothId)
    .where('name', 'in', names)
    .get();

  const ls: any[] = [];
  qs.forEach((doc) => {
    // console.log(doc)
    ls.push(doc.data());
  });
  return ls;
};

const pvit = async (brandId: string, itemId: string, names: string[]): Promise<any[]> => {
  const qs = await firebase
    .db()
    .collection('visitors_v1')
    .where('brandId', '==', brandId)
    .where('itemId', '==', itemId)
    .where('name', 'in', names)
    .get();

  const ls: any[] = [];
  qs.forEach((doc) => {
    // console.log(doc)
    ls.push(doc.data());
  });
  return ls;
};

export type BrandInfo = {
  brand: Brand;
  uu: number;
  pv: number;
  v: any;
}
export type BoothInfo = {
  booth: Booth;
  uu: number;
  pv: number;
  v: any;
}
export type ItemInfo = {
  item: Item;
  uu: number;
  pv: number;
  v: any;
}
// export type BoothInfo = { [key: string]: string[] };
// export type ItemInfo = { [key: string]: string[] };
// export type ExhibitionInfo = { [key: string]: string[] };

export type DataType = {
  brandInfo: BrandInfo | null;
  boothInfos: BoothInfo[];
  itemInfos: ItemInfo[];
  // itemInfo: ItemInfo | null;
  // exhibitionInfo: ExhibitionInfo | null;
};

export default Vue.extend({
  name: 'admin-analysis-user-detail',
  data(): DataType {
    return {
      brandInfo: null,
      boothInfos: [],
      itemInfos: [],
      // boothInfo: null,
      // itemInfo: null,
      // exhibitionInfo: null,
    };
  },
  async mounted() {
    this.$loading(true);
    try {
      const brandId: string = this.$route.params.id;
      const b = await brand.load(brandId);
      if (!b || !b.data.owner || !b.id) {
        throw new Error(`Can not find brandid:${brandId}`);
      }

      const qbrs = await pv(b.id, ['br-brandId']);
      this.brandInfo = {
        brand: b,
        uu: uu(qbrs).length,
        pv: qbrs.length,
        v: qbrs[0],
      };

      const bts = await booth.loadsByBrandId(b.data.owner, b.id);
      for (const bt of bts) {
        if (!bt.id) throw new Error('Can not bt.id');
        const bvs = await pvbt(b.id, bt.id, ['bt-boothId', 'exh-exhibitionId-bt-boothId']);
        console.log(bvs);
        this.boothInfos.push({
          booth: bt,
          uu: uu(bvs).length,
          pv: bvs.length,
          v: bvs[0],
        });
      }

      const its = await item.loadsByBrandId(b.data.owner, b.id);
      for (const it of its) {
        if (!it.id) throw new Error('Can not it.id');
        const ivs = await pvit(b.id, it.id, ['it-itemId', 'br-brandId-it-itemId']);
        this.itemInfos.push({
          item: it,
          uu: uu(ivs).length,
          pv: ivs.length,
          v: ivs[0],
        });
      }

      // const ret = await firebase.functions('admins-analysis-brand-getUniqueByBrand', {
      //   brandId: this.$route.params.id,
      // });

      // const {
      //   brandInfo,
      //   boothInfo,
      //   itemInfo,
      //   exhibitionInfo,
      // } = ret.data;

      // this.brandInfo = brandInfo;
      // this.boothInfo = boothInfo;
      // this.itemInfo = itemInfo;
      // this.exhibitionInfo = exhibitionInfo;
    } catch (error: any) {
      this.$error('ブランドの取得に失敗しました。', error);
    } finally {
      this.$loading(false);
    }
  },
});
